// extracted by mini-css-extract-plugin
module.exports = {"component":"destination-facts-table_component__mGISd","tableHeadline":"destination-facts-table_tableHeadline__hcbhh"};